// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"aaf8e899","496":"fd64dfe9","614":"044f15fb","664":"85f4be05","787":"56b06d95"}[chunkId] + ".chunk.js";
};